export const gmail = "dammirtaljanovic@gmail.com";
export const subject = "Contact";
export const body = ""; 